// action types
import { createRequestTypes } from "../../utils";

// Fetch batches
export const FETCH_BATCHES = createRequestTypes("FETCH_BATCHES");
export const FETCH_BATCH_DETAIL = createRequestTypes("FETCH_BATCH_DETAIL");

// Create/Update/Delete batch
export const CREATE_BATCH = createRequestTypes("CREATE_BATCH");
export const UPDATE_BATCH = createRequestTypes("UPDATE_BATCH");
export const DELETE_BATCH = createRequestTypes("DELETE_BATCH");
export const UPDATE_BATCH_STATUS = createRequestTypes("UPDATE_BATCH_STATUS");

// Notes
export const FETCH_BATCH_NOTES = createRequestTypes("FETCH_BATCH_NOTES");
export const CREATE_BATCH_NOTE = createRequestTypes("CREATE_BATCH_NOTE");
export const UPDATE_BATCH_NOTE = createRequestTypes("UPDATE_BATCH_NOTE");
export const DELETE_BATCH_NOTE = createRequestTypes("DELETE_BATCH_NOTE");

// Images
export const FETCH_BATCH_IMAGES = createRequestTypes("FETCH_BATCH_IMAGES");
export const UPLOAD_BATCH_IMAGE = createRequestTypes("UPLOAD_BATCH_IMAGE");
export const DELETE_BATCH_IMAGE = createRequestTypes("DELETE_BATCH_IMAGE");

// UI State
export const SET_BATCH_FILTERS = 'SET_BATCH_FILTERS';
export const CLEAR_BATCH_DETAIL = 'CLEAR_BATCH_DETAIL';
export const SET_SELECTED_BATCH = 'SET_SELECTED_BATCH';
export const CLEAR_BATCH_ERROR = 'CLEAR_BATCH_ERROR';

// ==================== BATCHES ====================

export const fetchBatchesRequest = (filters = {}) =>
    ({ type: FETCH_BATCHES.REQUEST, payload: filters });

export const fetchBatchesSuccess = (batches) =>
    ({ type: FETCH_BATCHES.SUCCESS, payload: batches });

export const fetchBatchesFailure = (error) =>
    ({ type: FETCH_BATCHES.FAILURE, payload: error });

export const fetchBatchDetailRequest = (batchId) =>
    ({ type: FETCH_BATCH_DETAIL.REQUEST, payload: { batchId } });

export const fetchBatchDetailSuccess = (batch) =>
    ({ type: FETCH_BATCH_DETAIL.SUCCESS, payload: batch });

export const fetchBatchDetailFailure = (error) =>
    ({ type: FETCH_BATCH_DETAIL.FAILURE, payload: error });

export const createBatchRequest = (batchData) =>
    ({ type: CREATE_BATCH.REQUEST, payload: batchData });

export const createBatchSuccess = (batch) =>
    ({ type: CREATE_BATCH.SUCCESS, payload: batch });

export const createBatchFailure = (error) =>
    ({ type: CREATE_BATCH.FAILURE, payload: error });

export const updateBatchRequest = (batchId, batchData) =>
    ({ type: UPDATE_BATCH.REQUEST, payload: { batchId, batchData } });

export const updateBatchSuccess = (batch) =>
    ({ type: UPDATE_BATCH.SUCCESS, payload: batch });

export const updateBatchFailure = (error) =>
    ({ type: UPDATE_BATCH.FAILURE, payload: error });

export const deleteBatchRequest = (batchId) =>
    ({ type: DELETE_BATCH.REQUEST, payload: { batchId } });

export const deleteBatchSuccess = (batchId) =>
    ({ type: DELETE_BATCH.SUCCESS, payload: { batchId } });

export const deleteBatchFailure = (error) =>
    ({ type: DELETE_BATCH.FAILURE, payload: error });

export const updateBatchStatusRequest = (batchId, status, extra = {}) =>
    ({ type: UPDATE_BATCH_STATUS.REQUEST, payload: { batchId, status, ...extra } });

export const updateBatchStatusSuccess = (batch) =>
    ({ type: UPDATE_BATCH_STATUS.SUCCESS, payload: batch });

export const updateBatchStatusFailure = (error) =>
    ({ type: UPDATE_BATCH_STATUS.FAILURE, payload: error });

// ==================== NOTES ====================

export const fetchBatchNotesRequest = (organizationId, batchId) =>
    ({ type: FETCH_BATCH_NOTES.REQUEST, payload: { organizationId, batchId } });

export const fetchBatchNotesSuccess = (notes) =>
    ({ type: FETCH_BATCH_NOTES.SUCCESS, payload: notes });

export const fetchBatchNotesFailure = (error) =>
    ({ type: FETCH_BATCH_NOTES.FAILURE, payload: error });

export const createBatchNoteRequest = (noteData) =>
    ({ type: CREATE_BATCH_NOTE.REQUEST, payload: noteData });

export const createBatchNoteSuccess = (note) =>
    ({ type: CREATE_BATCH_NOTE.SUCCESS, payload: note });

export const createBatchNoteFailure = (error) =>
    ({ type: CREATE_BATCH_NOTE.FAILURE, payload: error });

export const updateBatchNoteRequest = (noteId, noteData) =>
    ({ type: UPDATE_BATCH_NOTE.REQUEST, payload: { noteId, noteData } });

export const updateBatchNoteSuccess = (note) =>
    ({ type: UPDATE_BATCH_NOTE.SUCCESS, payload: note });

export const updateBatchNoteFailure = (error) =>
    ({ type: UPDATE_BATCH_NOTE.FAILURE, payload: error });

export const deleteBatchNoteRequest = (noteId) =>
    ({ type: DELETE_BATCH_NOTE.REQUEST, payload: { noteId } });

export const deleteBatchNoteSuccess = (noteId) =>
    ({ type: DELETE_BATCH_NOTE.SUCCESS, payload: { noteId } });

export const deleteBatchNoteFailure = (error) =>
    ({ type: DELETE_BATCH_NOTE.FAILURE, payload: error });

// ==================== IMAGES ====================

export const fetchBatchImagesRequest = (batchId) =>
    ({ type: FETCH_BATCH_IMAGES.REQUEST, payload: { batchId } });

export const fetchBatchImagesSuccess = (images) =>
    ({ type: FETCH_BATCH_IMAGES.SUCCESS, payload: images });

export const fetchBatchImagesFailure = (error) =>
    ({ type: FETCH_BATCH_IMAGES.FAILURE, payload: error });

export const uploadBatchImageRequest = (imageData) =>
    ({ type: UPLOAD_BATCH_IMAGE.REQUEST, payload: imageData });

export const uploadBatchImageSuccess = (image) =>
    ({ type: UPLOAD_BATCH_IMAGE.SUCCESS, payload: image });

export const uploadBatchImageFailure = (error) =>
    ({ type: UPLOAD_BATCH_IMAGE.FAILURE, payload: error });

export const deleteBatchImageRequest = (imageId) =>
    ({ type: DELETE_BATCH_IMAGE.REQUEST, payload: { imageId } });

export const deleteBatchImageSuccess = (imageId) =>
    ({ type: DELETE_BATCH_IMAGE.SUCCESS, payload: { imageId } });

export const deleteBatchImageFailure = (error) =>
    ({ type: DELETE_BATCH_IMAGE.FAILURE, payload: error });

// ==================== UI STATE ====================

export const setBatchFilters = (filters) =>
    ({ type: SET_BATCH_FILTERS, payload: filters });

export const clearBatchDetail = () =>
    ({ type: CLEAR_BATCH_DETAIL });

export const setSelectedBatch = (batch) =>
    ({ type: SET_SELECTED_BATCH, payload: batch });

export const clearBatchError = () =>
    ({ type: CLEAR_BATCH_ERROR });
